/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import clsx from 'clsx';

import s from './styles.module.less';

const sizeMap = {
  small: 10,
  middle: 20,
  large: 30,
};

const Block = ({ as: Component = 'div', className, variant, size = 'middle', spaced, style, ...props }) => (
  <Component
    className={clsx(className, s.root, spaced && s.spaced, s[variant])}
    style={{ padding: sizeMap[size] || size, ...style }}
    {...props}
  />
);

export default Block;
